import { Wordmark } from "@/components/site/Brand";
import { CLINIC } from "@/lib/data";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-olive-deep text-cream pt-20 pb-10 grain overflow-hidden" data-testid="footer">
      <div className="absolute -top-20 left-1/4 w-96 h-96 rounded-full bg-blush-dusty/10 blur-[100px]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <Wordmark dark />
            <p className="font-sans text-sm text-beige/80 mt-6 max-w-sm leading-relaxed">
              {CLINIC.full}. Compassionate women's health & fertility care in St. Inez, Goa.
            </p>
          </div>
          <div>
            <p className="font-sans text-xs tracking-[0.25em] uppercase text-beige mb-5">Visit us</p>
            <ul className="space-y-4 font-sans text-sm text-beige/80">
              <li className="flex gap-3"><MapPin className="w-4 h-4 shrink-0 mt-0.5 text-blush-pale" /><span>{CLINIC.address}</span></li>
              <li className="flex gap-3 items-center"><Phone className="w-4 h-4 shrink-0 text-blush-pale" /><a href="tel:+919322743917" data-testid="footer-phone" className="hover:text-cream transition-colors">{CLINIC.phone}</a></li>
              <li className="flex gap-3 items-center"><Mail className="w-4 h-4 shrink-0 text-blush-pale" /><a href={`mailto:${CLINIC.email}`} className="hover:text-cream transition-colors">{CLINIC.email}</a></li>
            </ul>
          </div>
          <div>
            <p className="font-sans text-xs tracking-[0.25em] uppercase text-beige mb-5">Explore</p>
            <ul className="space-y-3 font-sans text-sm text-beige/80">
              {["about", "services", "consultations", "gallery"].map((h) => (
                <li key={h}><a href={`#${h}`} className="hover:text-cream transition-colors capitalize">{h}</a></li>
              ))}
              <li><a href={CLINIC.calendly} target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">Book on Calendly</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex items-center justify-center">
          <p className="font-sans text-xs text-beige/60">© {new Date().getFullYear()} {CLINIC.full}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
